/*
*
* Script for cookies - you can use it everywhere you need
*
*/

/**
 * Sets a cookie with the specified name, value and expiry days
 * @param {string} name - Cookie name
 * @param {string|number} value - Cookie value
 * @param {number} days - Number of days until the cookie expires
 */
export const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

/**
 * Gets a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, null);
};

/**
 * Deletes a cookie by setting its expiry date to the past
 * @param {string} name - Cookie name to delete
 */
export const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

